import React, { useEffect, useRef, useState } from "react";
import { HomeWrapper } from "../components/utils/HomeWrapper";
import { useTranslation } from "react-i18next";
import { Paper, Typography, RadioGroup, FormControlLabel, Radio, Checkbox } from "@material-ui/core";
import surveyDataJson from '../assets/survey/survey001.json'; 
import logoSignamed from '../assets/logos/logo-blue-square.jpg';
import { Button, TextField, Select, MenuItem } from '@mui/material';
import QueuePlayNextIcon from '@mui/icons-material/QueuePlayNext';
import ThumbUpAltIcon from '@mui/icons-material/ThumbUpAlt';
import ThumbDownAltIcon from '@mui/icons-material/ThumbDownAlt';
import LSE_icon30 from '../assets/icons/LSE_icon30.jpeg'
import Tooltip from '@mui/material/Tooltip';
import { useTimerProvider } from '../api/TimerProvider';
import CircularProgress from '@mui/material/CircularProgress';
import SendIcon from "@mui/icons-material/Send";
import { IS } from "country-flag-icons/react/3x2";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { useDataProvider } from "../api/DataProvider";
import { useCommProvider } from "../api/CommProvider";
import { LinearProgress } from "@material-ui/core";
import { DeviceQueries } from "../components/utils/DeviceQueries";



export function Survey() {
    const { t } = useTranslation("global");

    const [ surveyBatch, setSurveyBatch ] = useState([]);
    const [ surveyData, setSurveyData ] = useState([]);
    const [ surveyId, setSurveyId ] = useState("id0000")
    const [ surveyKey, setSurveyKey ] = useState(null)
    const [ isLSE, setIsLSE ] = useState(null)
    const [selectedOptions, setSelectedOptions] = useState([]);

    const [ surveyBatchCounter, setSurveyBatchCounter ] = useState(0)
    const [ openTooltip, setOpenTooltip ] = useState(false);
    const [hoveredOption, setHoveredOption] = useState(null);
    const [isTooltipOpen, setIsTooltipOpen] = useState(false);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [videoLoaded, setVideoLoaded] = useState(false);

    const { comm_sendResponseSurvey } = useCommProvider();
    const { token_id, currentUser } = useDataProvider();

    const surveyResponse = useRef([]);
    const queryMatches = DeviceQueries();

    const { 
        timer, 
        timerActive, 
        setConfigTimer, 
        stopTimer 
    } = useTimerProvider();
  

    // const [ response, setResponse ] = useState({
    //     'qtype': '',
    //     'qid':'',
    //     'response': '',
    //     'lse': true,
    // })
    

    const obtainSurveyBatch = () => {
        const surveyBatchGenerated = [];
        // const getUniqueIds = (key, count) => {
        //     const ids = surveyDataJson['ids'][key];
        //     const uniqueIds = [];
        //     while (uniqueIds.length < count) {
        //         const randomIndex = Math.floor(Math.random() * ids.length);
        //         const selectedId = ids[randomIndex];
        //         if (!uniqueIds.includes(selectedId)) {
        //             uniqueIds.push(selectedId);
        //         }
        //     }
        //     return uniqueIds;
        // };

        const getUniqueIds = (key, count) => {
            const ids = surveyDataJson['ids'][key];
            const uniqueIds = [];
            const userPrefixes = new Set(); // Conjunto para almacenar los prefijos de usuario ya seleccionados
    
            while (uniqueIds.length < count && ids.length > userPrefixes.size) {
                const randomIndex = Math.floor(Math.random() * ids.length);
                const selectedId = ids[randomIndex];
                const userPrefix = selectedId.split('_')[0]; // Extraer el prefijo del usuario
    
                if (!userPrefixes.has(userPrefix)) { // Verificar si el prefijo del usuario ya fue seleccionado
                    uniqueIds.push(selectedId);
                    userPrefixes.add(userPrefix); // Agregar el prefijo del usuario al conjunto
                }
            }
            return uniqueIds;
        };

        // Get 5 unique IDs for p001
        const p001Ids = getUniqueIds('p01a', 5);
        p001Ids.forEach(id => surveyBatchGenerated.push({ key: 'p01a', id }));

        // Get 5 unique IDs for p002
        const p002Ids = getUniqueIds('p02a', 5);
        p002Ids.forEach(id => surveyBatchGenerated.push({ key: 'p02a', id }));

        // Get 3 unique IDs for p003
        const p003Ids = getUniqueIds('p03a', 3);
        p003Ids.forEach(id => surveyBatchGenerated.push({ key: 'p03a', id }));

        console.log("🚀 ~ obtainSurveyBatch ~ surveyBatchGenerated:", surveyBatchGenerated)
        setSurveyBatch(surveyBatchGenerated)
        setSurveyBatchCounter(1)
    }

    const updateSurveyData = (key, id) => {

        let surveyData = surveyDataJson[key]
        console.log("🚀 ~ useEffect ~ surveyData:", surveyData)

        function shuffleArray(array) {
            for (let i = array.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                [array[i], array[j]] = [array[j], array[i]];
            }
        }

        if (surveyData.hasOwnProperty('customOptions')) {
            let optionsList = surveyDataJson['customOptions'][id];
            shuffleArray(optionsList);
            surveyData['customOptions'] = optionsList
            surveyData['customOptionsLabel'] = surveyDataJson['customOptionsLabel']
        }

        setSurveyData(surveyData)
        setSurveyKey(key)
        setVideoLoaded(false);

    }

    useEffect(() => {
        console.log("🚀 ~ Survey ~ surveyBatch:", surveyBatch);
        if (surveyBatch.length > 0) {
            const { key, id } = surveyBatch[0];
            console.log(`Key: ${key}, ID: ${id}`);
            setSurveyId(id)
            console.log(`Set - variable >>> Key: ${key}, ID: ${id}`);

            updateSurveyData(key, id)
        }
    }, [surveyBatch]);


    const handleChange = (event) => {
        const selected_option_value_key = event.target.value;
        console.log("🚀 ~ handleChange ~ selected_option_value_key:", selected_option_value_key)

        let selected_option_value_data = undefined
        if ('customOptions' in surveyData) {
            selected_option_value_data = surveyData.customOptions[selected_option_value_key];
        }
        if (selected_option_value_data == undefined){
            selected_option_value_data = selected_option_value_key
        }
        
        console.log("🚀 ~ handleChange ~ selected_option_value_data:", selected_option_value_data)

        const response_idx = {[surveyKey]: selected_option_value_data}
        surveyResponse.current = [...surveyResponse.current, response_idx];

        if (selected_option_value_key in surveyData.next){
            console.log('next: ', surveyData.next[selected_option_value_key])
            setSurveyData([])
            updateSurveyData(surveyData.next[selected_option_value_key], surveyId)
        }else{
            console.log('end: ')
            setSurveyData([])
            sendSurveyResult()
        }
    }; 


    useEffect(() => {
        console.log("🚀 ~ Survey ~ surveyKey:", surveyKey)
        console.log("🚀 ~ Survey ~ surveyData:", surveyData)
        console.log("🚀 ~ Survey ~ surveyResponse:", surveyResponse.current)
        console.log("🚀 ~ Survey ~ selectedOptions:", selectedOptions)
    }, [surveyData, surveyResponse.current, selectedOptions]);



    useEffect(() => {
        if (isLSE!==null){

            if (surveyBatchCounter===1 || surveyBatchCounter===6 || surveyBatchCounter===11){
                setConfigTimer({
                    'label': 'PRE_VID_REF',
                    'start': 10,
                    'end': 0,
                    'step': 1,
                    'interval_ms': 100,
                    'onEnd': () => {}
                })
            }

        }
    }, [surveyBatchCounter, isLSE]);

    
    
    const handleCheckboxChange = (optionKey) => {
        setSelectedOptions((prevSelectedOptions) =>
            prevSelectedOptions.includes(optionKey)
                ? prevSelectedOptions.filter((key) => key !== optionKey)
                : [...prevSelectedOptions, optionKey]
        );
    };



    const handleSubmit = () => {
        const selected_options_activated = {[surveyKey]: selectedOptions};
        surveyResponse.current = [...surveyResponse.current, selected_options_activated];
    
        let foundNext = false;
        for (const option of selectedOptions) {
            if (option in surveyData.next) {
                console.log('next: ', surveyData.next[option]);
                setSurveyData([]);
                updateSurveyData(surveyData.next[option], surveyId);
                foundNext = true;
                break;
            }
        }
    
        if (!foundNext) {
            console.log('end: ');
            setSurveyData([]);
            sendSurveyResult();
        }
    };



    const sendSurveyResult = async () => {
        console.log("🚀 ~ sendSurveyResult ~ sendSurveyResult:", surveyResponse.current);

        const data_response= {
            "survey_id": "survey001",
            "question_id": surveyKey.slice(0, -1),
            "vid_id": surveyId,
            "is_lse": isLSE,
            "arr_responses": surveyResponse.current
        }

        console.log("🚀 ~ sendSurveyResult ~ data_response:", data_response)

        await comm_sendResponseSurvey(token_id, currentUser, data_response)

        surveyResponse.current = []
        setSelectedOptions([])
        
        setSurveyBatch(prevSurveyBatch => prevSurveyBatch.slice(1));
        setSurveyBatchCounter(surveyBatchCounter + 1)
        
    }

    useEffect(() => {
        console.log("🚀 ~ Survey ~ surveyBatchCounter:", surveyBatchCounter)
    }, [surveyBatchCounter]);


    function onLoadedVideo() {
        setVideoLoaded(true);
    }

    function adaptVideoRequirements(url_video) {
        console.log("🚀 ~ adaptVideoRequirements ~ url_video:", url_video)
        if (queryMatches.isMobile || window.innerWidth < 600) {
            console.log("🚀 ~ adaptVideoRequirements ~ url_video: USAR RESO MOVIL", url_video)
            url_video = url_video.replace("Survey001", "Survey001/260")
        } else {
            console.log("🚀 ~ adaptVideoRequirements ~ url_video: USAR RESO NAVEGADOR", url_video)
            url_video = url_video.replace("Survey001", "Survey001/420")
        }
        console.log("🚀 ~ adaptVideoRequirements ~ url_video: OUT", url_video)
        return url_video;
    }


    return (
        <HomeWrapper>
        <Paper style={{
            padding: "5px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            boxShadow: "0 3px 5px 2px rgba(255, 105, 135, .3)",
            width: '50%',
            minWidth: '350px',
            margin: "auto",
            marginTop: "20px",
            border: "3px solid #015ea3",
            backgroundColor: surveyBatchCounter > 10 ? '#ffcccb29' : // Rojo claro
                            surveyBatchCounter > 5 ? '#ffa5000a' : // Naranja claro
                            surveyBatchCounter > 0 ? '#90ee9012' : // Verde claro
                            'white', 
        }}>
            

            { surveyData && surveyData.length === 0 &&
                (
                    <>
                        { surveyBatchCounter === 0 ?
                            <>
                               <>   
                               <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'relative' }}>
                                    <img src={logoSignamed} alt="Survey Media" style={{ width: "20%", minWidth: '100px', borderRadius: "10px", margin: 'auto' }} />
                                    <strong
                                        style={{ color: "blue", cursor: "pointer", margin: "10px", position: 'absolute', top: 0, right: 0 }}
                                        onClick={(event) => {
                                            event.preventDefault();
                                            setIsDialogOpen(true);
                                        }}
                                    >
                                        <img src={LSE_icon30} alt="Icon" />
                                    </strong>
                                </div>

                                <Dialog
                                    open={isDialogOpen}
                                    onClose={() => setIsDialogOpen(false)}
                                    maxWidth="md"
                                    fullWidth
                                    PaperProps={{
                                        style: {
                                            position: 'absolute',
                                            top: 0,
                                            right: 0,
                                            margin: 0,
                                            width: '30%',
                                            minWidth: '200px'
                                        },
                                    }}
                                >
                                    <DialogContent style={{ padding: '2px' }}>
                                        {!videoLoaded && <LinearProgress color="primary" />}
                                        <video src={"https://lse.mvazquez.es:8443/data_main/Survey001/LSE/intro.mp4"} loop controls autoPlay muted style={{ width: '100%' }}  onLoadedData={onLoadedVideo} />
                                    </DialogContent>
                                </Dialog>

                                </>

                                <div style={{ fontFamily: 'Georgia, serif', color: '#333', padding: '20px'}}>
                                    <p style={{ margin: '0px', fontSize: '18px', lineHeight: '1.6' }}>
                                        La <strong style={{ fontWeight: 'bold' }}>Universidad de Sevilla</strong>, en colaboración con la <strong style={{ fontWeight: 'bold' }}>Universidad de Vigo</strong>, está trabajando en la anonimización de vídeos de personas signantes mediante técnicas de <strong style={{ fontWeight: 'bold' }}>face-swapping</strong> y el uso de <strong style={{ fontWeight: 'bold' }}>avatares</strong>.
                                    </p>
                                    <p style={{ margin: '0px', fontSize: '18px', lineHeight: '1.6' }}>
                                        El objetivo de esta encuesta es que personas como tú evalúen los resultados de este trabajo, específicamente:
                                    </p>
                                    <ul style={{ margin: '0px', fontSize: '18px', lineHeight: '1.6' }}>
                                        <li>Si se logra una <em style={{ fontStyle: 'italic' }}>anonimización efectiva</em>.</li>
                                        <li>Si el discurso sigue siendo <em style={{ fontStyle: 'italic' }}>comprensible</em> a pesar de ello, es decir, si los componentes manuales y no manuales son correctos.</li>
                                    </ul>
                                    {/* <p style={{ fontSize: '18px', lineHeight: '1.6' }}>
                                        Para responder a esta encuesta, primero vea un breve video y luego conteste algunas preguntas sobre él. <strong style={{ fontWeight: 'bold' }}>Gracias por tu participación.</strong>
                                    </p> */}
                                    <p style={{ fontSize: '18px', lineHeight: '1.6' }}>
                                        <strong style={{ fontWeight: 'bold' }}>Gracias por tu participación.</strong>
                                    </p>
                                </div>
                            </>
                            : 
                            <> {
                                surveyBatchCounter < 13 ?
                                
                                    <CircularProgress style={{marginTop: '50px', marginBottom: '40px'}} variant="indeterminate" />

                                :<div style={{ fontFamily: 'Georgia, serif', color: '#333', padding: '20px'}}>
                                    <p style={{ fontSize: '18px', lineHeight: '1.6' }}>
                                        Ha completado una tanda completa.
                                    </p>
                                    <p style={{ fontSize: '18px', lineHeight: '1.6' }}>
                                        <strong> Muchas gracias por su valiosa colaboración.</strong>
                                    </p>
                                    <br></br>
                                    <hr></hr>
                                    <br></br>
                                    <p style={{ fontSize: '18px', lineHeight: '1.6' }}>
                                        Si desea contribuir aún más a nuestra investigación, le invitamos a continuar con la siguiente tanda.
                                    </p>
                                    <p style={{ fontSize: '18px', lineHeight: '1.6' }}>
                                        <strong> Por favor, pulse el botón de continuar cuando esté listo. </strong>
                                    </p>
                                </div>
                                }
                                
                            </>
                        }

                        { (surveyBatchCounter === 0 || surveyBatchCounter > 13) &&
                            <Button className={`sig_SignDialog_Button sig_SignDialog_ButtonRecord`} style={{margin: '0px'}} onClick={obtainSurveyBatch}>
                                <QueuePlayNextIcon className="sig_Account_Icon"/>
                                {surveyBatchCounter > 0 ? "Repetir encuesta" :"Empezar"}
                            </Button>
                        }
                        

                        {/* <Button className={`sig_SignDialog_Button sig_SignDialog_ButtonRecord`} onClick={sendSurveyResult}>
                            <QueuePlayNextIcon className="sig_Account_Icon"/>
                            Enviar dato
                        </Button> */}
                        
                    
                    </>
                )
            }




            { surveyData && surveyData.length !== 0 && isLSE == null &&
                <>

<>   
                               <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'relative' }}>
                                    <img src={logoSignamed} alt="Survey Media" style={{ width: "20%", minWidth: '100px', borderRadius: "10px", margin: 'auto' }} />
                                    <strong
                                        style={{ color: "blue", cursor: "pointer", margin: "10px", position: 'absolute', top: 0, right: 0 }}
                                        onClick={(event) => {
                                            event.preventDefault();
                                            setIsDialogOpen(true);
                                        }}
                                    >
                                        <img src={LSE_icon30} alt="Icon" />
                                    </strong>
                                </div>

                                <Dialog
                                    open={isDialogOpen}
                                    onClose={() => setIsDialogOpen(false)}
                                    maxWidth="md"
                                    fullWidth
                                    PaperProps={{
                                        style: {
                                            position: 'absolute',
                                            top: 0,
                                            right: 0,
                                            margin: 0,
                                            width: '30%',
                                            minWidth: '200px'
                                        },
                                    }}
                                >
                                    <DialogContent style={{ padding: '2px' }}>
                                        <video src={"https://lse.mvazquez.es:8443/data_main/Survey001/LSE/00.mp4"} loop controls autoPlay muted style={{ width: '100%' }} />
                                    </DialogContent>
                                </Dialog>

                                </>


                
                    <div style={{ marginTop: '20px', fontSize: '17px' }}>Antes de empezar necesitamos saber... </div>
                    <div style={{ fontWeight: 'bold', fontSize: '25px' }}>¿ Entiendes LSE ?</div>
                    

                    <Button className={`sig_SignDialog_Button sig_SignDialog_ButtonRecord`} style={{ backgroundColor: 'green',marginTop: '40px', marginBottom: '-10px'}} onClick={ () => setIsLSE(true) }>
                        <ThumbUpAltIcon className="sig_Account_Icon"/> 
                            SI
                    </Button>

                    <Button className={`sig_SignDialog_Button sig_SignDialog_ButtonRecord`} style={{ backgroundColor: 'red' }} onClick={  () => setIsLSE(false) }>
                        <ThumbDownAltIcon className="sig_Account_Icon"/> 
                        NO
                    </Button>
                </>
            }

            { surveyData && surveyData.length !== 0 && isLSE !== null && timerActive && 
                <>  
                    <Paper style={{
                        padding: '10px',
                        width: '80%',
                        border: '1px solid #ccc',
                        backgroundColor: surveyBatchCounter > 10 ? 'red' : 
                                             surveyBatchCounter > 5 ? 'orange' : 
                                            'green', // Ajusta este color según necesites
                        color: 'white', // Texto blanco para mejor contraste
                        textAlign: 'center',
                        fontSize: '20px', // Texto más grande
                        borderRadius: "10px", // Bordes redondeados
                        marginBottom: '5px',
                        marginTop: '-20px'
                        }}>
                        <Typography variant="h5" component="h3" style={{ color: 'inherit' }}>
                            {surveyBatchCounter} / 13
                        </Typography>
                    </Paper>

                    <CircularProgress style={{marginTop: '50px', marginBottom: '40px'}}  variant="determinate" size={200} value={100 * timer / 10} />
                    
                    <Typography style={{ color:"#015ea3", fontSize: 'clamp(15px, 4vw, 25px)', marginBottom: "2px", fontWeight: 400 }}>
                        {surveyBatchCounter === 1 && "Cargando la primera parte de la encuesta ..."}
                        {surveyBatchCounter === 6 && "Cargando la segunda parte de la encuesta ..."}
                        {surveyBatchCounter === 11 && "Cargando la tercera parte de la encuesta ..."}
                    </Typography>
                    
                </>
            }


            { surveyData && surveyData.length !== 0 && isLSE !== null && !timerActive &&
                (
                    <>
                        { (surveyKey!=="p01b") && (
                            <Paper style={{
                                padding: '5px',
                                width: '80%',
                                border: '2px solid #ccc',
                                backgroundColor: surveyBatchCounter > 10 ? 'red' : 
                                                surveyBatchCounter > 5 ? 'orange' : 
                                                'green', // Ajusta este color según necesites
                                color: 'white', // Texto blanco para mejor contraste
                                textAlign: 'center',
                                fontSize: '20px', // Texto más grande
                                borderRadius: "10px", // Bordes redondeados
                                marginBottom: '5px',
                                marginTop: '-20px'
                                }}>
                                <Typography style={{ color: 'inherit' }}>
                                    {surveyBatchCounter} / 13
                                </Typography>
                            </Paper>
                        )}

                        {surveyData.mediaType.map((type, index) => (
                            <React.Fragment key={index}>
                                {type === "image" && (
                                    <img src={surveyData.mediaSrc[index].replace("{id}", surveyId)} alt="Survey Media" style={{ maxWidth: "70%", marginBottom: "1px", borderRadius: "4px" }} />
                                )}
                                {type === "video" && (
                                    <video src={adaptVideoRequirements(surveyData.mediaSrc[index].replace("{id}", surveyId))} autoPlay muted loop style={surveyKey == "p01b" ? { minWidth: '300px', maxWidth: "55%", maxHeight: "55%", borderRadius: "4px" } : { maxWidth: "80%", maxHeight: "80%", borderRadius: "4px" }} />

                                    
                                )}
                            </React.Fragment>
                        ))}

                        {/* <Typography style={{ color:"#015ea3", fontSize: '25px', marginTop: "5px", marginBottom: "2px", fontWeight: 400 }}> */}
                        <Typography style={{ color: "#015ea3", fontSize: 'clamp(15px, 4vw, 25px)', marginTop: "5px", marginBottom: "2px", fontWeight: 400 }}>

                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span style={{marginRight: '5px'}}>{surveyData.questionText[0]}</span>

                            <div
                                style={{ color: "blue", cursor: "pointer" }}
                                            onClick={(event) => {
                                                event.preventDefault();
                                                setIsDialogOpen(true);
                                            }}
                                        >
                                            <img src={LSE_icon30} alt="Icon" />
                                        </div>
                                        </div>
                            <Dialog
                                        open={isDialogOpen}
                                        onClose={() => setIsDialogOpen(false)}
                                        maxWidth="md"
                                        fullWidth
                                        PaperProps={{
                                            style: {
                                                position: 'absolute',
                                                top: 0,
                                                right: 0,
                                                margin: 0,
                                                width: '30%',
                                                minWidth: '200px'
                                            },
                                        }}
                                    >
                                        <DialogContent style={{padding: '2px'}}>
                                            <video src={surveyData.questionText[1]} loop controls autoPlay muted style={{ width: '100%' }} />
                                        </DialogContent>
                                    </Dialog>


                        </Typography>

                <div>
                    {(surveyData.multipleChoice !== undefined) ? (

                        <>
                            {surveyData.customOptions !== undefined && (
                                <>
                                    {Object.keys(surveyData.customOptions).map((optionKey) => (
                                        <div
                                            key={optionKey}
                                            style={{ display: 'flex', alignItems: 'center' }}
                                            onMouseEnter={() => setHoveredOption(optionKey)}
                                            onMouseLeave={() => setHoveredOption(null)}
                                        >
                                            <Checkbox
                                                checked={selectedOptions.includes(optionKey)}
                                                onChange={() => handleCheckboxChange(optionKey)}
                                            />
                                            <Typography
                                                style={{
                                                    // fontSize: '20px',
                                                    fontSize: 'clamp(15px, 4vw, 25px)',
                                                    color: hoveredOption === optionKey ? '#007bff' : '#333',
                                                    fontWeight: hoveredOption === optionKey ? '900' : 'normal',
                                                    lineHeight: '1.6',
                                                    marginLeft: '8px'
                                                }}
                                            >
                                                {surveyData.customOptionsLabel[surveyData.customOptions[optionKey]]}
                                            </Typography>
                                        </div>
                                    ))}
                                </>
                            )}
                            {Object.keys(surveyData.options).map((optionKey) => (
                                <div
                                    key={optionKey}
                                    style={{ display: 'flex', alignItems: 'center' }}
                                    onMouseEnter={() => setHoveredOption(optionKey)}
                                    onMouseLeave={() => setHoveredOption(null)}
                                >
                                    <Checkbox
                                        checked={selectedOptions.includes(optionKey)}
                                        onChange={() => handleCheckboxChange(optionKey)}
                                    />
                                    <Typography
                                        style={{
                                            // fontSize: '20px',
                                            fontSize: 'clamp(15px, 4vw, 25px)',
                                            color: hoveredOption === optionKey ? '#007bff' : '#333',
                                            fontWeight: hoveredOption === optionKey ? '900' : 'normal',
                                            lineHeight: '1.6',
                                            marginLeft: '8px'
                                        }}
                                    >
                                        {surveyData.options[optionKey]}
                                    </Typography>
                                </div>
                            ))}
                            <Button className="sig_SignDialog_Button" style={{minWidth: '200px'}} disabled={selectedOptions.length === 0} endIcon={<SendIcon />} onClick={handleSubmit}>
                                Enviar respuesta
                            </Button>
                        </>
                    ) : (
                        <RadioGroup name="surveyOptions" onChange={handleChange}>
                            {surveyData.customOptions !== undefined && (
                                <>
                                    {Object.keys(surveyData.customOptions).map((optionKey) => (
                                        <div
                                            key={optionKey}
                                            style={{ display: 'flex', alignItems: 'center' }}
                                            onMouseEnter={() => setHoveredOption(optionKey)}
                                            onMouseLeave={() => setHoveredOption(null)}
                                        >
                                            <Radio value={optionKey} />
                                            <Typography
                                                style={{
                                                    // fontSize: '20px',
                                                    fontSize: 'clamp(15px, 4vw, 25px)',
                                                    color: hoveredOption === optionKey ? '#007bff' : '#333',
                                                    fontWeight: hoveredOption === optionKey ? '900' : 'normal',
                                                    lineHeight: '1.6',
                                                    marginLeft: '8px'
                                                }}
                                            >
                                                {surveyData.customOptionsLabel[surveyData.customOptions[optionKey]]}
                                            </Typography>
                                        </div>
                                    ))}
                                </>
                            )}
                            {Object.keys(surveyData.options).map((optionKey) => (
                                <div
                                    key={optionKey}
                                    style={{ display: 'flex', alignItems: 'center' }}
                                    onMouseEnter={() => setHoveredOption(optionKey)}
                                    onMouseLeave={() => setHoveredOption(null)}
                                >
                                    <Radio value={optionKey} />
                                    <Typography
                                        style={{
                                            // fontSize: '20px',
                                            fontSize: 'clamp(15px, 4vw, 25px)',
                                            color: hoveredOption === optionKey ? '#007bff' : '#333',
                                            fontWeight: hoveredOption === optionKey ? '900' : 'normal',
                                            lineHeight: '1.6',
                                            marginLeft: '8px'
                                        }}
                                    >
                                        {surveyData.options[optionKey]}
                                    </Typography>
                                </div>
                            ))}
                        </RadioGroup>
                    )}
                </div>

                    </>
                )
            }

           
        </Paper>
        </HomeWrapper>
    );
}